/* ==========================================================================
   VELIORA — Wishlist (localStorage-based)
   ========================================================================== */
(function () {
  'use strict';
  const STORAGE_KEY = 'veliora:wishlist';
  const strings = (window.Veliora && window.Veliora.strings) || {};

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (err) {
      return [];
    }
  }
  function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = ids.length;
      el.style.display = ids.length > 0 ? '' : 'none';
    });
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids } }));
  }
  function isSaved(id) {
    return getWishlist().includes(String(id));
  }
  function toggle(id) {
    const ids = getWishlist();
    const idx = ids.indexOf(String(id));
    if (idx > -1) {
      ids.splice(idx, 1);
      saveWishlist(ids);
      Veliora.toast(strings.removedFromWishlist || 'Removed from wishlist');
      return false;
    }
    ids.push(String(id));
    saveWishlist(ids);
    Veliora.toast(strings.addedToWishlist || 'Added to wishlist');
    return true;
  }

  function syncButtons() {
    const ids = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const id = btn.getAttribute('data-wishlist-toggle');
      btn.classList.toggle('is-active', ids.includes(String(id)));
      btn.setAttribute('aria-pressed', ids.includes(String(id)) ? 'true' : 'false');
    });
    const countEls = document.querySelectorAll('[data-wishlist-count]');
    countEls.forEach((el) => {
      el.textContent = ids.length;
      el.style.display = ids.length > 0 ? '' : 'none';
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-wishlist-toggle');
    const saved = toggle(id);
    btn.classList.toggle('is-active', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  });

  window.Veliora = window.Veliora || {};
  Veliora.wishlist = { getWishlist, isSaved, toggle };

  document.addEventListener('DOMContentLoaded', syncButtons);
})();
